module.exports = __webpack_public_path__ + "static/media/ErrorGray.64eabf29.svg";